// Vite "Load Error Handling": a deploy deletes the hashed chunks of the previous
// build, so a tab opened before it fails to import them. Reloading fetches the
// new index.html. https://vite.dev/guide/build#load-error-handling
export const PRELOAD_RELOAD_KEY = "yalana:preload-reload-at";
export const RELOAD_COOLDOWN_MS = 10_000;

function reloadedRecently(now: number): boolean {
  try {
    const last = Number(sessionStorage.getItem(PRELOAD_RELOAD_KEY));
    return Number.isFinite(last) && now - last < RELOAD_COOLDOWN_MS;
  } catch {
    return false;
  }
}

function markReload(now: number): void {
  try {
    sessionStorage.setItem(PRELOAD_RELOAD_KEY, String(now));
  } catch {
    // Storage unavailable (private mode): reload anyway, loop guard degrades.
  }
}

export function registerReloadOnPreloadError(target: {
  reload: () => void;
}): () => void {
  const handler = (event: Event) => {
    const now = Date.now();
    if (reloadedRecently(now)) return;
    event.preventDefault();
    markReload(now);
    target.reload();
  };
  window.addEventListener("vite:preloadError", handler);
  return () => window.removeEventListener("vite:preloadError", handler);
}
